<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/permissao"> Cadastro/Acesso/Permissões </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Descrição *"
              v-model="descricao"
              :counter="200"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              :readonly="readOnly"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="2">
          <v-checkbox v-model="permissao.ativo" @click.native.stop.prevent="checkAssociacao()" label="Ativo" :readonly="readOnly"></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn to="/permissao" color="error" class="mr-4" v-if="!readOnly"> Voltar </v-btn>
          <v-btn to="/permissao" color="success" class="mr-4" v-else> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-row align="center-left">
        <v-col cols="12" sm="12">
          <v-card>
            <v-data-table
              :headers="headers"
              hide-default-footer
              disable-pagination
              :items="permissao.regras"
            >
              <template v-slot:item.leitura="{ item }">
                <v-checkbox v-model="item.leitura" :readonly="readOnly"></v-checkbox>
              </template>
              <template v-slot:item.escrita="{ item }">
                <v-checkbox v-model="item.escrita" :readonly="readOnly"></v-checkbox>
              </template>
            </v-data-table> </v-card
        ></v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { editarPermissaoAsync } from "../../../services/permissaoService";
import TabNavegacao from "../../Tabs/TabCadastroUsuario";
import { mapState, mapActions } from "vuex";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarPermissao",
  data: () => ({
    overlay: false,
    descricao: null,
    headers: [
      { text: "Regra", value: "modulo" },
      { text: "Leitura", value: "leitura", sortable: false },
      { text: "Escrita", value: "escrita", sortable: false },
    ],
  }),
  computed: {
    ...mapState("permissao", ["permissao"]),
    ...mapState("perfil", ["perfis"]),
  },
  methods: {
    ...mapActions("perfil", ["atualizarPerfis"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarPermissaoAsync(
          this.permissao.id,
          this.descricao,
          this.permissao.regras,
          this.permissao.ativo
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          /*this.$fire({
            text: "Usuário editado com sucesso",
            type: "success",
            timer: 3000,
          });*/
          this.overlay = false;
          this.$router.push("/permissao");
        }
      }
    },
    findPerfil(permissaoId) {
      return this.perfis.filter((p) => {
        return p.idPermissao == permissaoId && p.ativo === true;
      });
    },
    checkAssociacao: async function () {
      if (!this.permissao.ativo) {
        if (!this.perfis || this.perfis.length == 0) {
          this.overlay = true;
          await this.atualizarPerfis();
          this.overlay = false;
        }
        var perfis = this.findPerfil(this.permissao.id);
        if (perfis != null && perfis.length > 0) {
          this.$alert(
            "O(s) perfil(s) '" +
              perfis.map((e) => e.nome).join("', '") +
              "' estão ativos e associados a essa permissão.",
            "Ação não permitida!",
            "error"
          );
          this.permissao.ativo = !this.permissao.ativo;
        }
      }
    },
  },
  created: function () {
    this.readOnly = !getUserPermission(1);
    this.descricao = this.permissao.descricao;
  },
  components: {
    TabNavegacao,
  },
};
</script>